export const SEARCH = 'SEARCH';
export const SEARCH_CITY = `${SEARCH}/CITY`;
export const SEARCH_COUNTRY = `${SEARCH}/COUNTRY`;
